import { createApp } from "vue";
import App from '../components/sj/App.vue'
import store from '../store/sj/'
import SweetModal from "thomson-sweet-modal-vue/src/plugin.js"
import i18n from "../i18n"
import VueGtag from "vue-gtag"

const app = createApp(App);

app.config.productionTip = false;

app
.use(store)
.use(i18n)
.use(SweetModal)
.use(VueGtag, {
  globalObjectName: "gtag_wrapper",
  config: {
    id: "UA-228105-36",
    params: {
      send_page_view: false
    }
  }
})
.mount(`#thomsonwrapper-${process.env.VUE_APP_SCHEMA}`)